// Service catalog – keys map to translation keys in i18n
// Each service has `segments` array: which customer segments it primarily serves
import { PaintBucket, Wallpaper, Building2, Snowflake, TreePine, Sparkles, Hammer, Brush, SprayCan } from "lucide-react";

export const serviceCatalog = [
  // Malerarbeiten: Frisch gestrichenes Treppenhaus - klarer Malerarbeit
  { slug: "malerarbeiten", key: "malerarbeiten", icon: PaintBucket, segments: ["private", "commercial"], priorityPrivate: 1, priorityCommercial: 4,
    image: "/img/vn/nacher_treppe.jpeg" },
  // Tapezierarbeiten: Spachteltechnik Stucco (unter Tapezier in Katalog)
  { slug: "tapezier", key: "tapezier", icon: Wallpaper, segments: ["private"], priorityPrivate: 2, priorityCommercial: 8,
    image: "https://customer-assets.emergentagent.com/job_felber-werkstatt/artifacts/7tnifqqg_imgi_17_469677622_1571973704198569_607888900127216590_n.jpg" },
  // Fassadenarbeiten: klare Fassade eines EFH
  { slug: "fassaden", key: "fassaden", icon: Building2, segments: ["commercial", "private"], priorityPrivate: 3, priorityCommercial: 1,
    image: "/img/vn/nacher_haus.jpeg" },
  // Dämmung & Isolierung: Hausdach Sanierung (Dach + Dämmung)
  { slug: "daemmung", key: "daemmung", icon: Snowflake, segments: ["commercial"], priorityPrivate: 7, priorityCommercial: 2,
    image: "/img/vn/nacher_haus_dach.jpeg" },
  // Holzmalerei: Restaurierte Holztür - klarer Match
  { slug: "holzmalerei", key: "holzmalerei", icon: TreePine, segments: ["private", "commercial"], priorityPrivate: 4, priorityCommercial: 6,
    image: "/img/vn/nacher_tuer.jpeg" },
  // Stuckleisten: Edelputz Gewerberäume (Dekorative Stuck-Optik)
  { slug: "stuck", key: "stuck", icon: Sparkles, segments: ["private", "commercial"], priorityPrivate: 5, priorityCommercial: 7,
    image: "https://customer-assets.emergentagent.com/job_felber-werkstatt/artifacts/9n9kzw3q_imgi_16_469940810_1571973810865225_8283317874212856176_n.jpg" },
  // Trockenbau: Trockenbau-Decke
  { slug: "trockenbau", key: "trockenbau", icon: Hammer, segments: ["commercial", "private"], priorityPrivate: 6, priorityCommercial: 3,
    image: "https://customer-assets.emergentagent.com/job_felber-werkstatt/artifacts/7h182mtx_imgi_34_181395631_598121021583847_8485609350374162520_n.jpg" },
  // Putzarbeiten: Gipser-/Putzarbeit
  { slug: "putz", key: "putz", icon: Brush, segments: ["commercial", "private"], priorityPrivate: 8, priorityCommercial: 5,
    image: "https://customer-assets.emergentagent.com/job_felber-werkstatt/artifacts/exz0w5yu_imgi_33_181585679_598121048250511_4110692841013163325_n.jpg" },
  // Spritzarbeiten: Frisch lackierte Fensterrahmen (Spritzwerkstatt-Resultat)
  { slug: "spritz", key: "spritz", icon: SprayCan, segments: ["commercial"], priorityPrivate: 9, priorityCommercial: 9,
    image: "https://customer-assets.emergentagent.com/job_felber-werkstatt/artifacts/xt02kt8x_imgi_28_181912503_598121194917163_4710678370177743932_n.jpg" },
];

// Returns services sorted by priority for a given segment
export const getServicesBySegment = (segment) => {
  const key = segment === "commercial" ? "priorityCommercial" : "priorityPrivate";
  return [...serviceCatalog].sort((a, b) => a[key] - b[key]);
};
